import config from './config.en';
import list from './list.en';
export default {
    breadcrumb: 'Calendar',
    config,
    list,
};
